import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserGroup } from '../../../classes/models/user/UserGroup';
import { UserGroupAdapter } from '../../../classes/adapters/response/user/UserGroupAdapter';
import { CreateUserGroupRequest, EditUserGroupRolesRequest } from '../../../interfaces/request/UserRequests';
import { UserGroupResponse } from '../../../interfaces/response/UserResponses';

/**
 * This service communicates with backend to manage user groups.
 */
@Injectable({
  providedIn: 'root'
})
export class UserGroupsService {
  private http = inject(HttpClient);
  private userGroupAdapter = inject(UserGroupAdapter);

  url = environment.apiUrl + '/user-groups';

  /**
   * Retrieves a list of user groups.
   */
  getUserGroups(): Observable<UserGroup[]> {
    return this.http.get(this.url).pipe(
      map((data: UserGroupResponse[]) => data.map(item => this.userGroupAdapter.adapt(item))));
  }

  /**
   * Updates access roles for the given user group.
   * @param userGroup user group to be updated.
   */
  updateUserGroupAccess(userGroup: UserGroup) {
    const url = `${this.url}/${userGroup.email}`;
    const request: EditUserGroupRolesRequest = {accessRules: userGroup.accessRules};
    return this.http.patch(url, request);
  }

  /**
   * Adds a new user group.
   * @param userGroup a new user group to be created.
   */
  addUserGroup(userGroup: UserGroup) {
    const url = `${this.url}`;
    const requestBody: CreateUserGroupRequest = {
      email: userGroup.email,
      description: userGroup.description
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Deletes an existing user group.
   * @param email an email of a user group.
   */
  deleteUserGroup(email: string) {
    const url = `${this.url}/${email}`;
    return this.http.delete(url);
  }
}
